export default __webpack_public_path__ + "static/media/1608.49941588.png";